<template>
    <div class="request-trip-container">
        <div v-if="isLocationEnabled && requestAddress && currentZona" class="float-container--top">
            <div class="card card-adress">
                <div class="card-row row-greeting" v-if="settings.modulo_mostrar_saludo_en_home">
                    {{ this.translate('saludo', { name: user.nombre }) }}
                </div>
                <div class="card-row">
                    <div class="card-left">
                        <svg-item v-if="!requestingAdress" :size="24" :icon="'gps'" :color="'--card-origin-title'"></svg-item>
                        <loader v-if="requestingAdress" :size="24" :flag="true" :customAttribute="{tag: 'circle', children: 0, attribute:'stroke', value: '--card-origin-title'}" ></loader>
                    </div>
                    <div class="card-center" :class="{'card-right--not' : !settings.modulo_edicion_manual_direccion_origen}" v-if="!requestingAdress">
                        <span class="card-title" v-if="!editingLocation"> {{ computedAddress }} </span>
                        <locationAutocomplete ref="location-edition" id="location-edition" class="form-input--location_edition" v-if="editingLocation" v-on:direction_change="changeLocation" v-on:input_blur="blurAdressComplete" :initialValue="customRequestAddress.title" :mustFocus="true" :placeholder-text="translate('placeholderInputOrigen')"></locationAutocomplete>
                        <span class="card-subtitle"> {{ customRequestAddress.subtitle || requestAddress.barrio }} </span>
                    </div>
                    <div class="card-right" v-if="settings.modulo_edicion_manual_direccion_origen && !requestingAdress">
                        <button class="btn btn-transparent" v-show="!editingLocation" @click="editLocation"><svg-item v-show="!requestingAdress" :size="16" :icon="'editar'" :color="'--card-origin-title'"></svg-item></button>
                        <button id="check_button" ref="check_button" class="btn btn-transparent" v-show="editingLocation" @click="editLocation"><svg-item v-show="!requestingAdress" :size="16" :icon="'check'" :color="'--card-subtitle'"></svg-item></button>
                    </div>
                </div>
                <div class="card-row card-row--destination" v-if="settings.modulo_destino_viaje">
                    <div class="card-left">
                        <svg-item :size="24" :icon="'lugar'" :color="'--card-destination-title'"></svg-item>
                    </div>
                    <div class="card-center">
                        <span class="card-title" v-if="!editingDestination"> {{ destinationAddress ? destinationAddress.description : ''}} </span>
                        <locationAutocomplete :initial-value="destinationAddress ? destinationAddress.description : null" v-if="editingDestination" ref="destination-edition" id="destination-edition" :placeholder-text="settings.destino_opcional ? translate('destinoOpcional') : translate('placeholderText')" class="autocomplete_destination" v-on:direction_change="onDestinationChange"></locationAutocomplete>
                    </div>
                    <div class="card-right" v-if="settings.modulo_edicion_manual_direccion_origen">
                        <button class="btn btn-transparent" v-show="!editingDestination" @click="editDestination"><svg-item :size="16" :icon="'editar'" :color="'--main-color'"></svg-item></button>
                        <button id="check_button" ref="check_button" class="btn btn-transparent" v-show="editingDestination && destinationAddress && destinationAddress.description" @click="editDestination"><svg-item :size="16" :icon="'check'" :color="'--main-color'"></svg-item></button>
                    </div>
                </div>

                <div class="card-row card-row--company" v-if="settings.modulo_empresas && availableCompanies && availableCompanies.length">
                    <div class="card-left">
                        <svg-item :size="24" :icon="'store'" :color="'--card-origin-title'"></svg-item>
                    </div>
                    <div class="card-center">
                        <label class="sr-only" for="empresa_taxi">Empresa de taxi</label>
                        <select class="form-control" id="empresa_taxi" v-model="empresaTaxi">
                            <option value="0" v-lang:cualquierEmpresa>{{ this.translate('cualquierEmpresa')}}</option>
                            <option v-for="e in availableCompanies" :value="e.id" :key="e.id">{{ e.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="card-row card-row--cars" v-if="settings.modulo_tipo_vehiculos">
                    <div class="card-left">
                        <svg-item :size="24" :icon="'taxi'" :color="'--card-origin-title'"></svg-item>
                    </div>
                    <div class="card-center">
                        <label class="sr-only" for="empresa_taxi">Tipo de vehiculo</label>
                        <select class="form-control" id="empresa_taxi" v-model="tipoVehiculo" @change="onCarChange">
                            <option v-for="c in availableCars" :value="c.id" :key="c.id">{{ $translateFromText(c.name) }}</option>
                        </select>
                    </div>
                </div>
                <div class="card-row card-row--cars" v-if="settings.modulo_tipo_servicios">
                    <div class="card-left">
                        <svg-item :size="24" :icon="'category'" :color="'--card-origin-title'"></svg-item>
                    </div>
                    <div class="card-center">
                        <label class="sr-only" for="tipo_servicio">Tipo de servicios</label>
                        <select class="form-control" id="tipo_servicio" v-model="tipoServicio" @change="onServiceChange">
                            <option v-for="s in availableServices" :value="s.id" :key="s.id">{{ $translateFromText(s.name) }}</option>
                        </select>
                    </div>
                </div>
                <div class="card-row card-row--cars" v-if="settings.modulo_diferenciar_genero">
                    <div class="card-left">
                        <svg-item :size="24" :icon="'gender'" :color="'--card-origin-title'"></svg-item>
                    </div>
                    <div class="card-center">
                        <label class="sr-only" for="gender">Género</label>
                        <select class="form-control" id="gender" v-model="gender">
                            <option value="N">{{ $translateFromText('Sin preferencia') }}</option>
                            <option value="M">{{ $translateFromText('Mujer') }}</option>
                            <option value="V">{{ $translateFromText('Varón') }}</option>
                        </select>
                    </div>
                </div>

                <div class="card-row card-row--company" v-if="!settings.deshabilitar_comentario">
                    <div class="card-left">
                        <svg-item :size="24" :icon="'comment'" :color="'--card-origin-title'"></svg-item>
                    </div>
                    <div class="card-center">
                        <label class="sr-only" for="comentario">Comentario</label>
                        <input type="text" v-model="comentario" id="comentario" placeholder="Ingrese su comentario" />
                    </div>
                </div><div class="card-row card-row--price"  v-if="settings.modulo_precio_viaje && ((tripEstimatedPrice > 0 && currentZona && currentZona.max_recharge == 0) || settings.precio_visible_como_ayuda)">
                    <strong>{{ !settings.precio_final ? this.translate('precioEstimado') : this.translate('precioFinal') }}:</strong>
                    <span v-if="!(requestingAdress || priceLoader) && tripEstimatedPrice > 0">
                        <span v-if="precioSinDescuento > 0" class="price-with-discount">
                            <span class="price-original">
                                <span v-lang.precioPrefijo></span>
                                {{ precioSinDescuento | numberFormatter }}
                                <span v-lang.precioSufijo></span>
                            </span>
                            <strong>
                                <span v-lang.precioPrefijo></span>
                                {{ tripEstimatedPrice | numberFormatter }}
                                <span v-lang.precioSufijo></span>
                            </strong>
                            <span
                                v-if="descuentoEstimacionTipo === 'atajo'"
                                class="discount-label"
                            >{{ translate('descuentoAtajoZonaAplicado', { pct: descuentoEstimacionPctLabel }) }}</span>
                            <span
                                v-else-if="descuentoEstimacionTipo === 'residente'"
                                class="discount-label"
                            >{{ translate('descuentoResidenteJubiladoAplicado', { pct: descuentoEstimacionPctLabel }) }}</span>
                            <span
                                v-else
                                class="discount-label"
                            >{{ pctDescuentoInferido !== '' && pctDescuentoInferido != null ? translate('descuentoTarifaAplicado', { pct: pctDescuentoInferido }) : translate('descuentoTarifaAplicadoFallback') }}</span>
                        </span>
                        <template v-else>
                            <strong>
                                <span v-lang.precioPrefijo></span>
                                {{ tripEstimatedPrice | numberFormatter }}
                                <span v-lang.precioSufijo></span>
                            </strong>
                        </template>
                        <span v-if="settings.destino_precio_leyenda"> - </span>
                        <span v-lang.destinoPrecioLeyenda v-if="settings.destino_precio_leyenda"></span>
                    </span>
                    <p
                        v-if="showDescuentoBeneficioPendienteEstimacion"
                        class="discount-pending-hint"
                    >{{ translate('descuentoBeneficioPendienteEstimacion', { pct: descuentoBeneficioPendientePctLabel }) }}</p>
                    <div
                        v-if="estimatedRouteDistanceMeters != null && !(requestingAdress || priceLoader) && (tripEstimatedPrice > 0 || viaje_afuera)"
                        class="card-row--distance-estimate"
                    >
                        {{ translate('estimacionDistancia') }}:
                        {{ (estimatedRouteDistanceMeters / 1000) | distanceConverter(settings.medidas_en_millas) | distanceFormatter(settings.medidas_en_millas, 'big') }}
                    </div>
                    <span v-lang.destinoPrecioAyuda v-if="tripEstimatedPrice <= 0 && settings.precio_visible_como_ayuda"></span>
                    <loader v-if="requestingAdress || priceLoader" :size="16" :flag="true" :customAttribute="{tag: 'circle', children: 0, attribute:'stroke', value: '--main-color'}" ></loader>
                </div>

                <div class="card-row card-row--company" v-if="settings.modulo_pasajero_viaje_afuera && viaje_afuera">
                    <div class="card-left">
                        <svg-item :size="24" :icon="'gender'" :color="'--main-color'"></svg-item>
                    </div>
                    <div class="card-center">
                        <label for="viaje_afuera">
                            {{ this.translate('viaje_afuera')}}
                        </label>
                    </div>
                </div>

                <div class="card-row card-row--payment-method" v-if="settings.modulo_pasajero_pago_electronico">
                    <div class="form-radio--block">
                        <input type="radio" id="rad_efectivo" aria-label="Efectivo" v-bind:value="0" v-model='pagoElectronico' />
                        <label class="form-label" for="rad_efectivo">
                            <svg-item v-if="!requestingAdress" :size="24" :icon="'cash'" :color="'--card-origin-title'"></svg-item>
                            <span class="form-radio--block-text" v-lang:efectivo>Efectivo</span>
                        </label>
                    </div>
                    <div class="form-radio--block">
                        <input type="radio" id="rad_tarjeta" aria-label="Pago electrónico" v-bind:value="1" v-model='pagoElectronico' />
                        <label class="form-label" for="rad_tarjeta">
                            <svg-item v-if="!requestingAdress" :size="24" :icon="'credit-card'" :color="'--card-origin-title'"></svg-item>
                            <span class="form-radio--block-text" v-lang:pagoElectronico>Pago electrónico</span>
                        </label>
                    </div>
                </div>

                <div class="card-row card-row--company" v-if="settings.modulo_pasajero_mascotas">
                    <!--<div class="card-left">
                        <svg-item :size="24" :icon="'gender'" :color="'--main-color'"></svg-item>
                    </div>-->
                    <div>{{ this.translate('viajo_con')}}</div>
                    <div class="card-center">
                        <input type="checkbox" v-model="mascotas" id="mascotas">
                        <label for="mascotas" style="margin-right: 10px;">
                            {{ this.translate('mascotas')}}
                        </label>
                        <input type="checkbox" v-model="maletas" id="maletas">
                        <label for="maletas" style="margin-right: 10px;">
                            {{ this.translate('maletas')}}
                        </label>
                        <input type="checkbox" v-model="silla_ruedas" id="silla_ruedas">
                        <label for="silla_ruedas">
                            {{ this.translate('silla_ruedas')}}
                        </label>
                    </div>
                </div>

                <!-- <div class="card-row card-row--company" v-if="settings.modulo_pasajero_maletas">
                    <div class="card-left">
                        <svg-item :size="24" :icon="'gender'" :color="'--main-color'"></svg-item>
                    </div>
                    <div class="card-center">
                    </div>
                </div>

                <div class="card-row card-row--company" v-if="settings.modulo_pasajero_silla_ruedas">
                    <div class="card-left">
                        <svg-item :size="24" :icon="'gender'" :color="'--main-color'"></svg-item>
                    </div>
                    <div class="card-center">
                    </div>
                </div>-->



                <div class="card-row card-row--company" v-if="!settings.deshabilitar_ida_vuelta">
                    <div class="card-left">
                        <svg-item :size="24" :icon="'repeat'" :color="'transparent'"></svg-item>
                    </div>
                    <div class="card-center">
                        <input type="checkbox" v-model="esIdaVuelta" id="esIdaVuelta" @change="calculateEstimatedPrice">
                        <label for="esIdaVuelta">
                            {{ this.translate('deIdaVuelta')}}
                        </label>
                    </div>
                </div>

                <div class="card-row card-row--company" v-if="settings.modulo_reserva_de_viajes">
                    <div class="card-left">
                        <svg-item :size="24" :icon="'calendar'" :color="'--card-origin-title'"></svg-item>
                    </div>
                    <div class="card-center card-center--reserva">
                        <input type="checkbox" v-model="esConReserva" id="esConReserva">
                        <label for="esConReserva">
                            {{ this.translate('esUnaReserva')}}
                        </label>
                        <p class="reserva-help">
                            {{ this.translate('reservaPedidoAhoraAyuda') }}
                        </p>
                        <template v-if="esConReserva">
                            <div class="reserva-datetime">
                                <label class="sr-only" for="fechaReserva">{{ this.translate('fechaReserva') }}</label>
                                <input type="date" v-model="fechaReserva" id="fechaReserva" :min="minFechaReserva" class="form-control form-control--date" />
                                <label class="sr-only" for="horaReserva">{{ this.translate('horaReserva') }}</label>
                                <input type="time" v-model="horaReserva" id="horaReserva" :min="minHoraReserva" class="form-control form-control--time" />
                            </div>
                        </template>
                    </div>
                </div>


                <div class="card-row card-row--payment-method" v-if="settings.modulos_pagos_en_la_app && settings.metodos_pago && settings.metodos_pago.length > 0">
                    <!-- <h4 v-lang.metodosPago class="h-payment-method">Métodos de pagos</h4> -->
                    <div class="card-left">
                        <svg-item :size="24" :icon="this.translate('iconMoney')" :color="'--main-color'"></svg-item>
                    </div>
                    <div class="card-center"><!-- class="payment-method-radios" -->
                        <span v-for="(method, index) in settings.metodos_pago" :key="index" class="payment-method-radio">
                            <input type="radio" :id="'pm_' + method.id" :value="method.id" v-model="paymentMethodSelected" :disabled="method.no_configuration === 0 && user.metodosPagosConfigurados.find(m => m.payment_method_id === method.id) === undefined" @change="showConfigPaymentMethod(method)">
                            <label :for="'pm_' + method.id">
                                {{ vm.translate(method.name) }}
                                <span v-if="method.options && method.options.recharge_value > 0">
                                    ({{ (method.options.recharge_type == 'P' ? '' : '$') + method.options.recharge_value + (method.options.recharge_type == 'P' ? '%' : '') }})
                                </span>
                            </label>
                        </span>
                    </div>
                    <template v-if="customComponent !== ''">
                        <component v-bind:is="customComponent" :ref="'paymentComponent'" ref="paymentComponent" :paymentmethod="customPaymentMethod" :pmconfig="customPaymentMethodConfig" v-on:success="onPaymentNegotationSuccess" :showbutton="false" :showmode="'payment'"></component>
                    </template>
                </div>
            </div>
        </div>
        <div class="float-container--bottom">
            <div id="dropin-container"></div>
            <div class="shortcuts-wrapper">
                <button class="btn btn-secondary shortcut-my-coupons" v-if="settings &&settings.modulo_promociones" @click="onGoToPromotions">
                    <svg-item  :size="24" :icon="'coupon'" :color="'white'"></svg-item>
                    <span v-lang.myCoupons>Mis cupones</span>
                </button>
                <button class="shortcuts-laucher btn btn-circle btn-secondary" aria-label="Mi posición" v-show="locationShorcuts.length === 0" @click="myPosition">
                    <svg-item  :size="28" :icon="'gps'" :color="'--secondary-button-fg-color'"></svg-item>
                </button>
                <button class="shortcuts-laucher btn btn-circle btn-secondary" aria-label="Atajos" v-if="locationShorcuts.length > 0" @click="onShortcutToggle" :class="settings.modulo_logo_primer_atajo ? 'logo-first-shortcut' : ''">
                    <template v-if="settings.modulo_logo_primer_atajo">
                        <img :src="generateShortcutImagePath(locationShorcuts[0].image)" class="shortcut-icon-laun" />
                    </template>
                    <template v-else>
                        <svg-item :size="28" :custom="true" :icon="'shortcut'" :color="'white'"></svg-item>
                    </template>
                </button>
                <div class="hidden-screen" v-show="shortcutsExpanded" @click="onShortcutToggle">
                </div>
                <div class="shorcuts-list card" v-show="shortcutsExpanded">
                    <button class="shortcut-item" @click="myPosition">
                        <svg-item :size="28" :icon="'gps'" :color="'--main-color'" class="shortcut-item_image"></svg-item>
                        <span class="shortcut-item_description">
                            <span class="shortcut-item_title text-strong shortcut-item-my_ubication" v-lang.myUbication>Mi ubicación actual</span>
                        </span>
                    </button>
                    <button
                        v-for="shortcut in locationShorcuts"
                        class="shortcut-item"
                        :class="{'shortcut-item--discount': selectedShortcutHasDiscount(shortcut)}"
                        @click="jumpToAddress(shortcut)"
                        v-bind:key="shortcut.id"
                    >
                        <img :src="generateShortcutImagePath(shortcut.image)" class="shortcut-item_image" />
                        <span class="shortcut-item_description">
                            <span class="shortcut-item_title text-strong">{{ shortcut.title }}</span>
                            <span
                                v-if="selectedShortcutHasDiscount(shortcut)"
                                class="shortcut-item_discount"
                            >{{ translate('descuentoAtajoZonaAplicado', { pct: shortcut.descuento }) }}</span>
                            <span class="shortcut-item_address">{{ shortcut.direccion }} {{ shortcut.numero > 0 ? (numberPrefix() + ' ' + shortcut.numero) : '' }} {{ shortcut.barrio ? ( ' - ' + shortcut.barrio) : '' }}</span>
                        </span>
                    </button>
                </div>
            </div>
            <transition name="fade" mode="out-in" v-if="showRequestButton">
                <button class="btn btn-primary btn-lg btn-heavy" v-if="isLocationEnabled" @click="onRequestTrip" :disabled="disabledCondition" v-lang.pedirTaxi>
                    Pedir Móvil
                </button>
                <template v-else>
                    <onLocationOff></onLocationOff>
                </template>
            </transition>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import bus from '@/services/bus-event';
import { Geocoding } from '@/services/geocoding';
import { estimateTripTariff } from '@/services/tripTariff';
import { consumePendingTripQuote, makeLatLngCompat } from '@/services/tripQuoteBridge';
import dialogs from '@/services/dialogs';
import { _normalizeText, _blankSpaceIfNotExist, showCancelModal } from '@/services/utility';
import BraintreePayment from '../../components/BraintreePayment';
import PaymentezPayment from '../../components/PaymentezPayment';
import VisanetPayment from '../../components/VisanetPayment';
/* eslint-disable no-undef */

export default {
    name: 'passengerTripRequest',
    props: [

    ],
    data () {
        return {
            requestPosition: null,
            requestAddress: null,
            customRequestAddress: {
                title: null,
                subtitle: null
            },
            editingLocation: false,
            editingDestination: true,
            loading: false,
            requestingAdress: true,
            destinationAddress: null,
            tripEstimatedPrice: 0,
            estimatedRouteDistanceMeters: null,
            estimatedRouteDurationSeconds: null,
            shortcutsExpanded: false,
            priceLoader: false,
            ignoreNextGeocoding: false,
            hasCustomPosition: false,
            pagoElectronico: false,
            mostrar_mensaje_ubicacion_editable: false,
            empresaTaxi: 0,
            tipoVehiculo: 1,
            tipoServicio: 1,
            comentario: '',
            esIdaVuelta: false,
            vm: this,
            paymentMethodSelected: 1, // efectivo,
            customComponent: '',
            customPaymentMethod: null,
            showRequestButton: true,
            customPaymentMethodConfig: null,
            priceRecharge: null,
            gender: 'N', // Valor por defecto: Sin preferencia
            mascotas: false,
            maletas: false,
            silla_ruedas: false,
            viaje_afuera: false,
            precioSinDescuento: 0,
            /** 'atajo' | 'residente' | null (null = API antigua o inferir) */
            descuentoEstimacionTipo: null,
            descuentoEstimacionPct: null,
            selectedShortcutId: null,
            esConReserva: false,
            fechaReserva: '',
            horaReserva: '',
            postAuthAlertsHandled: false
        };
    },

    computed: {
        ...mapGetters({
            logged: 'auth/checkLogin',
            user: 'auth/user',
            recentLogin: 'auth/recentLogin',
            recentRegister: 'auth/recentRegister',
            isMobile: 'device/isMobile',
            isLocationEnabled: 'geolocation/locationEnabled',
            currentPosition: 'geolocation/actual',
            settings: 'company/config',
            currentZona: 'geolocation/actualZona',
            isRequesting: 'passenger/isRequesting',
            canceledTrip: 'passenger/canceledTrip',
            hasFirstRemoteState: 'passenger/hasFirstRemoteState',
            isInternetOnline: 'device/internetOnline',
            platform: 'cordova/platform',
            isDriver: 'auth/isChofer'
        }),
        disabledCondition () {
            let baseCondition = !this.requestAddress || this.loading || this.requestingAdress || (this.settings.modulo_destino_viaje && !this.destinationAddress && !this.settings.destino_opcional);

            // Si precio_final está activado, no permitir pedir viaje si el precio estimado es <= 0
            if (this.settings.precio_final && this.tripEstimatedPrice <= 0) {
                return true;
            }

            return baseCondition;
        },
        minFechaReserva () {
            const nowAr = this.getNowInArgentinaParts();
            return `${nowAr.year}-${nowAr.month}-${nowAr.day}`;
        },
        minHoraReserva () {
            if (!this.fechaReserva || this.fechaReserva !== this.minFechaReserva) {
                return '';
            }
            const nowAr = this.getNowInArgentinaParts();
            return `${nowAr.hour}:${nowAr.minute}`;
        },
        locationShorcuts () {
            return this.currentZona && this.currentZona.atajos ? this.currentZona.atajos : [];
        },
        computedAddress () {
            if (this.customRequestAddress.title) {
                return this.customRequestAddress.title;
            } else {
                if (this.requestAddress.calle) {
                    if (this.currentZona && this.currentZona.pais === 'usa') {
                        return (this.requestAddress.numero > 0 ? this.requestAddress.numero + ' ' : '') + this.requestAddress.calle;
                    } else {
                        return this.requestAddress.calle + ' ' + (this.requestAddress.numero > 0 ? this.numberPrefix() + this.requestAddress.numero : '');
                    }
                } else {
                    return this.translate('calleSinNombre');
                }
            }
        },
        availableCompanies () {
            let companies = [];
            if (this.settings.modulo_empresas && this.settings.empresas && this.settings.empresas.length) {
                if (this.currentZona && this.currentZona.id) {
                    companies = this.settings.empresas.filter(c => !c.zona_id || c.zona_id === this.currentZona.id);
                }
            }
            return companies;
        },
        availableCars () {
            let cars = [];
            if (this.settings.modulo_tipo_vehiculos && this.settings.tiposVehiculo && this.settings.tiposVehiculo.length) {
                cars = this.settings.tiposVehiculo.filter(c => c.active);
            }
            return cars;
        },
        availableServices () {
            let services = [];
            if (this.settings.modulo_tipo_servicios && this.settings.tiposServicio && this.settings.tiposServicio.length) {
                services = this.settings.tiposServicio.filter(c => c.active);
            }
            return services;
        },
        descuentoEstimacionPctLabel () {
            if (this.descuentoEstimacionPct != null && this.descuentoEstimacionPct !== '') {
                return this.descuentoEstimacionPct;
            }
            if (this.descuentoEstimacionTipo === 'residente' && this.settings && this.settings.descuento_residente_jubilado != null) {
                return this.settings.descuento_residente_jubilado;
            }
            const inf = this.pctDescuentoInferido;
            if (inf !== '' && inf != null) {
                return inf;
            }
            return '';
        },
        pctDescuentoInferido () {
            const sin = Number(this.precioSinDescuento);
            const fin = Number(this.tripEstimatedPrice);
            if (!sin || sin <= 0 || !fin || fin < 0 || fin >= sin) {
                return '';
            }
            return Math.round((1 - fin / sin) * 100);
        },
        beneficioStatus () {
            if (!this.user || !this.user.tipo_beneficio) return null;
            if (
                this.user.beneficio_descuento_aprobado === true ||
                this.user.beneficio_descuento_aprobado === 1 ||
                this.user.beneficio_descuento_aprobado === '1'
            ) return 'aprobado';
            if (
                this.user.beneficio_descuento_rechazado === true ||
                this.user.beneficio_estado === 'rechazado' ||
                this.user.estado_beneficio_descuento === 'rechazado'
            ) {
                return 'rechazado';
            }
            return 'pendiente';
        },
        showDescuentoBeneficioPendienteEstimacion () {
            return !this.isDriver &&
                this.settings.modulo_descuento_residente_jubilado &&
                this.beneficioStatus === 'pendiente' &&
                this.tripEstimatedPrice > 0 &&
                !(this.requestingAdress || this.priceLoader);
        },
        descuentoBeneficioPendientePctLabel () {
            if (this.settings && this.settings.descuento_residente_jubilado != null) {
                return this.settings.descuento_residente_jubilado;
            }
            return '';
        }
    },
    activated () {
        this.refreshUserIfBeneficioDescuento();
        if (!this.applyPendingTripQuoteFromBridge()) {
            this.applyCurrentPositionAsOrigin();
        }
    },
    mounted () {
        this.refreshUserIfBeneficioDescuento();
        this.language = this.$getLang();
        // this.settings.modulo_destino_viaje = true; - Just for testing
        bus.on('map_point_selected', this.onLocationChangedOnMap);
        bus.on('drag_start', this.onDragStart);
        bus.on('keyboard-hidden', this.keyboardHidden);
        bus.on('trip_canceled', this.myPosition);
        if (!this.applyPendingTripQuoteFromBridge()) {
            this.applyCurrentPositionAsOrigin();
        }
        // this.showMensajeEdicionEditable();
        this.doConfiguration();
        console.log('canceledTrip mounted', this.canceledTrip);
        if (this.canceledTrip) {
            this.onCanceledTrip(this.canceledTrip);
        }
        // this.showMensajeEdicionEditable();
        console.log('RequestTrip user', this.user);
        if (this.user && this.user.default_payment_method_id > 0) {
            this.paymentMethodSelected = this.user.default_payment_method_id;
            console.log(this.settings.metodos_pago);
            let method = this.settings.metodos_pago.find(m => m.id === this.user.default_payment_method_id);
            this.showConfigPaymentMethod(method, true);
        }

        this.tryShowPostAuthAlerts();

        // Inicializar gender con valor por defecto si el módulo está activado
        if (this.settings.modulo_diferenciar_genero && !this.gender) {
            this.gender = 'N';
        }
    },
    updated () {
    },

    watch: {
        recentLogin () {
            this.tryShowPostAuthAlerts();
        },
        recentRegister () {
            this.tryShowPostAuthAlerts();
        },
        settings () {
            this.tryShowPostAuthAlerts();
        }
    },

    methods: {
        getNowInArgentinaParts () {
            const formatter = new Intl.DateTimeFormat('en-CA', {
                timeZone: 'America/Argentina/Buenos_Aires',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            });
            const parts = formatter.formatToParts(new Date());
            const byType = {};
            parts.forEach((part) => {
                byType[part.type] = part.value;
            });
            return {
                year: byType.year,
                month: byType.month,
                day: byType.day,
                hour: byType.hour,
                minute: byType.minute
            };
        },
        isReservaAfterArgentinaNow (fecha, hora) {
            if (!fecha || !hora) return false;
            const [hour, minute] = hora.split(':');
            const nowAr = this.getNowInArgentinaParts();
            const selectedKey = `${fecha} ${hour}:${minute}`;
            const nowKey = `${nowAr.year}-${nowAr.month}-${nowAr.day} ${nowAr.hour}:${nowAr.minute}`;
            return selectedKey > nowKey;
        },
        ...mapActions({
            createTrip: 'passenger/createTrip',
            setRequestPosition: 'passenger/setRequestPosition',
            callToLocationSettings: 'geolocation/callToLocationSettings',
            caceledViewed: 'passenger/cancelarVisto',
            changeRecentLogin: 'auth/changeRecentLogin',
            changeRecentRegister: 'auth/changeRecentRegister',
            refreshUser: 'auth/refreshUser',
            // user: 'auth/user',
            confirmInternetConnection: 'device/confirmInternetConnection'
        }),
        tryShowPostAuthAlerts () {
            if (this.postAuthAlertsHandled || (!this.recentLogin && !this.recentRegister)) {
                return;
            }
            if (!this.settings) {
                return;
            }
            this.postAuthAlertsHandled = true;
            const showRegisterAsDriverPostLogin = () => {
                if (!this.settings.modulo_chofer_upgrade || this.isDriver) {
                    return;
                }
                const msg = this.translate('registerAsDriverPostLogin', {
                    menuItem: this.translate('upgradeTitle')
                });
                this.$alertForgettable('register_as_driver_post_login', msg, { isModal: true });
            };
            if (this.settings.mostrar_mensaje_tras_login) {
                let msg = this.settings.mostrar_mensaje_tras_login.mensaje;
                if (this.settings.mostrar_mensaje_tras_login.i18n) {
                    msg = this.settings.mostrar_mensaje_tras_login.i18n[this.language];
                }
                this.$alertForgettable('mostrar_mensaje_tras_login', msg, {
                    callback: showRegisterAsDriverPostLogin
                });
            } else {
                showRegisterAsDriverPostLogin();
            }
            this.changeRecentLogin(false);
            this.changeRecentRegister(false);
        },
        refreshUserIfBeneficioDescuento () {
            if (this.isDriver || !this.settings.modulo_descuento_residente_jubilado || !this.user || !this.user.tipo_beneficio) {
                return Promise.resolve();
            }
            return this.refreshUser().then(() => {
                if (this.settings.modulo_precio_viaje && this.requestPosition && this.requestPosition.location && this.destinationAddress && this.destinationAddress.location) {
                    this.calculateEstimatedPrice();
                }
            }).catch(() => {});
        },
        numberPrefix () {
            return (this.currentZona && this.currentZona.pais === 'col') ? '#' : '';
        },
        blurAdressComplete (value) {
            if (!this.settings.modulo_autocomplete_obligatorio) {
                this.customRequestAddress.title = value;
            }
        },
        changeLocation (result) {
            this.customRequestAddress.title = result.description;
            this.customRequestAddress.subtitle = result.barrio && (_normalizeText(result.barrio)) !== (_normalizeText(this.currentZona.ciudad)) ? result.barrio : '';
            this.editLocation();
            let address = {
                lat: result.location.lat(),
                lng: result.location.lng(),
                direccion: result.calle,
                numero: result.numero,
                barrio: result.barrio
            };
            this.jumpToAddress(address, true);
        },
        editLocation () {
            if (!this.editingLocation) {
                this.customRequestAddress.title = this.customRequestAddress.title || (this.requestAddress.calle + ' ' + (this.requestAddress.numero > 0 ? this.numberPrefix() + this.requestAddress.numero : ''));
                this.editingLocation = true;
                if (this.$refs['location-edition']) {
                    this.$refs['location-edition'].focus();
                }
            } else {
                this.editingLocation = false;
                if (this.$refs['location-edition']) {
                    this.$refs['location-edition'].blur();
                }
            }
        },
        editDestination () {
            this.editingDestination = !this.editingDestination;
        },
        keyboardHidden () {
            if (this.requestPosition) {
                bus.emit('set_center', this.requestPosition.location);
                if (!this.hasCustomPosition) {
                    this.doReverseGeocoding(this.requestPosition.location);
                }
            } else if (this.currentPosition) {
                bus.emit('set_center', this.currentPosition);
                this.doReverseGeocoding(this.currentPosition);
            }
        },
        buildTripPayload (paymentInfo, hasPaymentModule) {
            const vm = this;
            const data = {
                lat: vm.currentPosition ? vm.currentPosition.lat : 0,
                lng: vm.currentPosition ? vm.currentPosition.lng : 0,
                comentario: vm.comentario,
                calle: vm.requestAddress.calle,
                altura: vm.requestAddress.numero,
                barrio: vm.requestAddress.barrio
            };
            if (vm.customRequestAddress && vm.customRequestAddress.title) {
                data.calle = vm.customRequestAddress.title;
                data.altura = -1;
                data.barrio = vm.customRequestAddress.subtitle;
            }
            if (vm.requestPosition) {
                data.lat = vm.requestPosition.location.lat;
                data.lng = vm.requestPosition.location.lng;
            }
            if (vm.settings.modulo_destino_viaje && vm.destinationAddress) {
                data.dest_lat = vm.destinationAddress.location.lat();
                data.dest_lng = vm.destinationAddress.location.lng();
                data.dest_nombre = vm.destinationAddress.description;
            }
            if (vm.settings.modulo_destino_viaje && vm.settings.modulo_precio_viaje) {
                data.precio = vm.tripEstimatedPrice;
                if (vm.estimatedRouteDistanceMeters != null) {
                    data.estimated_route_distance_meters = vm.estimatedRouteDistanceMeters;
                }
                if (vm.estimatedRouteDurationSeconds != null) {
                    data.estimated_route_duration_seconds = vm.estimatedRouteDurationSeconds;
                }
            }
            if (vm.selectedShortcutId) {
                data.shortcut_id = vm.selectedShortcutId;
            }
            if (vm.selectedShortcutId || (vm.locationShorcuts && vm.locationShorcuts.length)) {
                vm.logTarifaAtajo('buildTripPayload (crear viaje)', {
                    shortcut_id: data.shortcut_id,
                    precio: data.precio,
                    estimated_route_distance_meters: data.estimated_route_distance_meters,
                    estimated_route_duration_seconds: data.estimated_route_duration_seconds
                });
            }
            if (vm.settings.modulo_pasajero_pago_electronico) {
                data.pago_electronico = vm.pagoElectronico;
            }
            if (vm.settings.modulo_pasajero_mascotas) {
                data.mascotas = vm.mascotas;
            }
            if (vm.settings.modulo_pasajero_maletas) {
                data.maletas = vm.maletas;
            }
            if (vm.settings.modulo_pasajero_silla_ruedas) {
                data.silla_ruedas = vm.silla_ruedas;
            }
            if (vm.settings.modulo_pasajero_viaje_afuera) {
                data.viaje_afuera = vm.viaje_afuera;
            }
            if (vm.settings.modulo_empresas) {
                data.company_id = vm.empresaTaxi;
            }
            if (vm.settings.modulo_tipo_vehiculos) {
                data.vehicle_type_id = vm.tipoVehiculo;
            }
            if (vm.settings.modulo_tipo_servicios) {
                data.service_type_id = vm.tipoServicio;
            }
            if (vm.settings.modulo_diferenciar_genero) {
                data.gender = vm.gender;
            }
            data.ida_vuelta = vm.esIdaVuelta;
            if (vm.settings.modulo_reserva_de_viajes && vm.esConReserva) {
                data.es_con_reserva = true;
                data.fecha_hora_reserva = vm.fechaReserva && vm.horaReserva
                    ? (vm.fechaReserva + ' ' + vm.horaReserva + ':00')
                    : null;
            }
            if (hasPaymentModule) {
                data.payment_method_id = vm.paymentMethodSelected;
                data.payment_info = paymentInfo;
            }
            return data;
        },
        onRequestTrip () {
            console.log('onRequestTrip', this.$refs && this.$refs.paymentComponent);
            if (this.$refs && this.$refs.paymentComponent) {
                this.$refs.paymentComponent.onSubmit(false).then((result) => {
                    console.log('onRequestTrip onSubmit', result);
                    this.doRequestTrip(result);
                }).catch((err) => {
                    console.log('error on submit', err);
                    dialogs.message(this.translate('errorWithPayment'), { duration: 10, estado: 'error' });
                });
            } else {
                this.doRequestTrip();
            }
        },
        doRequestTrip (paymentInfo) {
            this.confirmInternetConnection();
            setTimeout(() => {
                console.log('isInternetOnline', this.isInternetOnline);
                if (!this.isInternetOnline) {
                    this.loading = false;
                    dialogs.message(this.translate('conectionError'), { duration: 10, estado: 'error' });
                }
            }, 1500);
            const isReservaRequest = this.settings.modulo_reserva_de_viajes && this.esConReserva;
            let hasPaymentModule = this.settings.modulos_pagos_en_la_app && this.settings.metodos_pago && this.settings.metodos_pago.length > 0;
            // Reserva con pago diferido: no cobramos al momento de crear la orden.
            if (isReservaRequest) {
                hasPaymentModule = false;
                paymentInfo = null;
            }
            if (hasPaymentModule) {
                if (this.paymentMethodSelected > 0) {
                    let method = this.settings.metodos_pago.find(m => m.id === this.paymentMethodSelected);
                    if (!method || (!method.no_configuration && !paymentInfo)) {
                        dialogs.message(this.translate('mustChoosePayment'), { duration: 10, estado: 'error' });
                        return;
                    } else {
                        console.log('paymentMethod', method);
                        if (method.no_configuration > 0 && method.options && method.options.is_electronic_payment) {
                            paymentInfo = { is_electronic_payment: true };
                        }
                        console.log('paymentInfo', paymentInfo);
                    }
                } else {
                    dialogs.message(this.translate('mustChoosePayment'), { duration: 10, estado: 'error' });
                    return;
                }
            }
            // console.log('doRequestTrip'); return;
            if (this.editingLocation) {
                this.editLocation();
            }
            if (this.requestAddress) {
                if (this.settings.modulo_destino_viaje && !this.destinationAddress && !this.settings.destino_opcional) {
                    dialogs.message(this.translate('emptyDestinationError'), { duration: 10, estado: 'error' });
                    return;
                }
                if (!this.areServiceCompatible()) {
                    dialogs.message(this.translate('serviceIncompatible'), { duration: 10, estado: 'error' });
                    return;
                }
                if (this.settings.modulo_diferenciar_genero && !this.gender) {
                    dialogs.message('Debe seleccionar una preferencia de género', { duration: 10, estado: 'error' });
                    return;
                }
                if (this.settings.modulo_reserva_de_viajes && this.esConReserva) {
                    if (!this.fechaReserva || !this.horaReserva) {
                        dialogs.message(this.translate('reservaFechaHoraRequeridas'), { duration: 10, estado: 'error' });
                        return;
                    }
                    if (!this.isReservaAfterArgentinaNow(this.fechaReserva, this.horaReserva)) {
                        dialogs.message(this.translate('reservaFechaHoraFuturas'), { duration: 10, estado: 'error' });
                        return;
                    }
                    const payload = this.buildTripPayload(paymentInfo, hasPaymentModule);
                    const monto = payload.precio || this.tripEstimatedPrice;
                    const data = { ...payload, monto };
                    // Create reservation trip without payment. It will be offered to drivers.
                    this.createTrip(data).then(() => {
                        dialogs.message(this.translate('reservaListo'), { duration: 5, estado: 'success' });
                    }).catch(() => {
                        dialogs.message(this.translate('problemaInesperado'), { duration: 10, estado: 'error' });
                    });
                    return;
                }
                let vm = this;
                let successFn = function () {
                    let data = vm.buildTripPayload(paymentInfo, hasPaymentModule);
                    vm.loading = true;
                    vm.loading = false;
                    console.log('vm.createTrip');
                    vm.createTrip(data).then((tripData) => {
                        console.log('then create trip', tripData);
                        if (vm.settings.modulo_promociones || vm.user.tester) {
                            dialogs.message(vm.translate('noOlvidesCuponPromocion'), { duration: 10, estado: 'success', position: 'bottom' });
                        }
                        if (tripData.payment_message && tripData.payment_message.length > 0 && tripData.payment_success + '' === '0') {
                            dialogs.message(vm.translate('errorPagoElectronico'), { duration: 15, estado: 'error', position: 'bottom' });
                        }
                    }).catch((err) => {
                        vm.showRequestButton = true;
                        vm.loading = false;
                        if ((err && err.message === 'Network Error') || (window.navigator && window.navigator.connection && window.navigator.connection.type === 'none')) {
                            dialogs.message(vm.translate('conectionError'), { duration: 10, estado: 'error' });
                        } else if (err && err.data === 'out_of_region') {
                            dialogs.message(vm.translate('outOfRegion'), { duration: 10, estado: 'error' });
                        } else {
                            dialogs.message(vm.translate('problemaInesperado'), { duration: 10, estado: 'error' });
                        }
                        console.error('err0r creating', err);
                    });
                };
                if (this.settings.modulo_confirmacion_direccion) {
                    let addressMessage = this.customRequestAddress.title ? this.customRequestAddress.title + _blankSpaceIfNotExist(this.customRequestAddress.subtitle, ' - ') : this.requestAddress.calle + (this.requestAddress.numero > 0 ? ' ' + this.numberPrefix() + this.requestAddress.numero : '') + _blankSpaceIfNotExist(this.requestAddress.barrio, ' - ');
                    this.showRequestButton = false;
                    dialogs.confirm(this.translate('confirmacionDireccion') + addressMessage + '?', (index) => {
                        if (index === 1) {
                            successFn();
                        } else {
                            this.showRequestButton = true;
                        }
                    }, this.translate('pedirTaxi'), [this.translate('si'), this.translate('no')]);
                }
            }
        },
        onActivateLocation () {
            this.callToLocationSettings();
        },
        onLocationChangedOnMap (pos) {
            // This method is called when user manually moves the map to select a position
            // OR when the map moves programmatically (but isProgrammaticMove should prevent this)

            // The ignoreNextGeocoding flag prevents immediate updates after jumpToAddress
            // This is critical to prevent programmatic map movements from overriding custom positions
            if (this.ignoreNextGeocoding) {
                console.log('onLocationChangedOnMap: Ignoring map position change, ignoreNextGeocoding is set (recent jumpToAddress call)');
                // Don't reset ignoreNextGeocoding here - let jumpToAddress handle it
                return;
            }

            // IMPORTANT: If hasCustomPosition is set, we should NOT allow map movements to override it
            // unless the user explicitly dragged the map (which resets hasCustomPosition in onDragStart)
            // This prevents programmatic movements from overriding custom positions
            if (this.hasCustomPosition && this.requestPosition) {
                // Check if positions are significantly different
                const latDiff = Math.abs(pos.location.lat - this.requestPosition.location.lat);
                const lngDiff = Math.abs(pos.location.lng - this.requestPosition.location.lng);
                const threshold = 0.001; // Increased threshold to be more conservative

                // If position is very similar, it's definitely a programmatic movement - ignore it
                if (latDiff < threshold && lngDiff < threshold) {
                    console.log('onLocationChangedOnMap: Ignoring map position change, position is too similar (likely programmatic movement)');
                    return;
                }

                // Even if position is different, if hasCustomPosition is still true, it means
                // onDragStart was NOT called, so this is NOT a user drag - ignore it
                // User drags will reset hasCustomPosition in onDragStart before this is called
                console.log('onLocationChangedOnMap: Ignoring map position change, hasCustomPosition is set and user did not drag (likely programmatic)');
                return;
            }

            // Only update if hasCustomPosition is false (user can freely move map)
            this.requestPosition = pos;
            this.setRequestPosition(pos.location);
            this.doReverseGeocoding(pos.location);
        },
        areServiceCompatible () {
            // this.settings.modulo_tipo_vehiculos
            // this.settings.modulo_tipo_servicios
            // this.settings.tiposVehiculo
            // this.settings.tiposServicio
            // this.tipoVehiculo
            // this.tipoServicio
            if (this.settings.modulo_tipo_vehiculos && this.settings.modulo_tipo_servicios) {
                if (this.settings.tiposVehiculo && this.settings.tiposVehiculo.length && this.settings.tiposServicio && this.settings.tiposServicio.length) {
                    let veh = this.settings.tiposVehiculo.find(v => v.id === this.tipoVehiculo);
                    console.log('veh', veh);
                    if (veh && veh.servicios && veh.servicios.length) {
                        let serv = veh.servicios.find(s => s.id === this.tipoServicio);
                        if (serv) {
                            console.log('areServiceCompatible', true);
                            return true;
                        }
                    }
                    console.log('areServiceCompatible', false);
                    return false;
                }
            }
            console.log('areServiceCompatible true', true);
            return true;
        },
        getGeocoding () {
            // Get geocoding runtime from settings, default to 'google'
            let runtime = (this.settings && this.settings.modulo_geocoding) || 'google';
            return new Geocoding(runtime);
        },
        formatAddressLine (address) {
            if (!address || !address.calle) {
                return '';
            }
            if (this.currentZona && this.currentZona.pais === 'usa') {
                return ((address.numero > 0 ? address.numero + ' ' : '') + address.calle).trim();
            }
            return (address.calle + ' ' + (address.numero > 0 ? this.numberPrefix() + address.numero : '')).trim();
        },
        syncOriginDisplayFromAddress (address) {
            if (!address) {
                return;
            }
            const needsCustomFields = this.settings.no_autocompletar_mapa
                || this.settings.modulo_edicion_manual_direccion_origen;
            if (!needsCustomFields) {
                return;
            }
            const title = this.formatAddressLine(address);
            if (title) {
                this.customRequestAddress.title = title;
            }
            this.customRequestAddress.subtitle = address.barrio || '';
        },
        applyCurrentPositionAsOrigin () {
            if (!this.isLocationEnabled || !this.currentPosition || this.hasCustomPosition) {
                return;
            }
            if (this.requestPosition && this.requestAddress) {
                return;
            }
            this.myPosition();
        },
        applyPendingTripQuoteFromBridge () {
            const quote = consumePendingTripQuote();
            if (!quote) {
                return false;
            }
            const originLat = quote.origin_lat;
            const originLng = quote.origin_lng;
            const destLat = quote.dest_lat;
            const destLng = quote.dest_lng;
            if (![originLat, originLng, destLat, destLng].every((v) => typeof v === 'number' && Number.isFinite(v))) {
                return false;
            }

            this.hasCustomPosition = true;
            this.ignoreNextGeocoding = false;
            this.requestingAdress = false;
            this.editingLocation = false;
            this.editingDestination = false;

            this.requestPosition = {
                location: { lat: originLat, lng: originLng }
            };
            this.requestAddress = {
                calle: quote.origin_desc || '',
                numero: -1,
                barrio: ''
            };
            this.customRequestAddress = {
                title: quote.origin_desc || '',
                subtitle: ''
            };

            this.destinationAddress = {
                description: quote.dest_desc || '',
                location: makeLatLngCompat(destLat, destLng)
            };

            if (quote.es_ida_vuelta) {
                this.esIdaVuelta = true;
            }
            if (quote.tipo_vehiculo) {
                this.tipoVehiculo = quote.tipo_vehiculo;
            }
            if (quote.tipo_servicio) {
                this.tipoServicio = quote.tipo_servicio;
            }

            this.$store.commit('geolocation/SET_POSITION', { lat: originLat, lng: originLng });
            this.$store.commit('geolocation/LOCATION_ENABLED_SET', true);

            this.$nextTick(() => {
                bus.emit('set_center', { lat: originLat, lng: originLng });
                if (this.settings && this.settings.modulo_precio_viaje) {
                    this.calculateEstimatedPrice();
                }
            });
            return true;
        },
        doReverseGeocoding (location, force) {
            if (location && (!this.requestPosition || force)) {
                this.requestPosition = {
                    location: {
                        lat: location.lat,
                        lng: location.lng
                    }
                };
            }
            let geocoding = this.getGeocoding();
            geocoding.reverse(location).then((result) => {
                if (!this.ignoreNextGeocoding || force) {
                    this.requestAddress = result;
                    this.syncOriginDisplayFromAddress(result);
                    let doEstimation = (this.currentZona && this.currentZona.enable_costs && this.settings.modulo_precio_viaje);
                    console.log('doEstimation', doEstimation, this.currentZona, this.settings.modulo_precio_viaje);
                    if (doEstimation && this.destinationAddress) {
                        this.calculateEstimatedPrice();
                    }
                    this.requestingAdress = false;
                    if (force) {
                        this.ignoreNextGeocoding = false;
                    }
                } else {
                    this.ignoreNextGeocoding = false;
                }
            }).catch(() => {
                this.requestingAdress = false;
                if (force) {
                    this.ignoreNextGeocoding = false;
                }
            });
        },
        onDragStart () {
            // User is manually dragging the map - reset hasCustomPosition to allow new selection
            console.log('onDragStart: User started dragging map, resetting hasCustomPosition');
            this.hasCustomPosition = false;
            this.selectedShortcutId = null;

            if (this.settings.modulo_edicion_manual_direccion_origen) {
                this.customRequestAddress.title = null;
                this.customRequestAddress.subtitle = null;
            }
            this.requestingAdress = true;
            if (this.ignoreNextGeocoding) {
                this.ignoreNextGeocoding = false;
            }
            if (this.editingLocation) {
                this.editingLocation = false;
                this.customRequestAddress.title = null;
                this.customRequestAddress.subtitle = null;
            }
        },
        onDestinationChange (result) {
            // Ojo que es un objeto de geocode modificado
            if (!this.requestingAdress && this.requestAddress) {
                this.destinationAddress = result;
                if (this.settings.modulo_precio_viaje) {
                    this.calculateEstimatedPrice();
                }
                this.editDestination();
            }
        },
        onCarChange () {
            if (this.settings.modulo_precio_viaje) {
                this.calculateEstimatedPrice();
            }
        },
        onServiceChange () {
            if (this.settings.modulo_precio_viaje) {
                this.calculateEstimatedPrice();
            }
        },
        async calculateEstimatedPrice () {
            if (this.requestPosition && this.requestPosition.location && this.destinationAddress && this.destinationAddress.location) {
                this.priceLoader = true;
                this.viaje_afuera = false;
                this.estimatedRouteDistanceMeters = null;
                this.estimatedRouteDurationSeconds = null;

                let geocoding = this.getGeocoding();

                const calculateRouteWithRetry = async (maxRetries = 3) => {
                    for (let attempt = 1; attempt <= maxRetries; attempt++) {
                        try {
                            const result = await geocoding.calculateRoute(
                                this.requestPosition.location,
                                {lat: this.destinationAddress.location.lat(), lng: this.destinationAddress.location.lng()}
                            );
                            return result;
                        } catch (error) {
                            console.error(`Error calculating route (attempt ${attempt}/${maxRetries}):`, error);

                            if (attempt === maxRetries) {
                                dialogs.message(this.translate('errorCalculandoPrecio') || 'No se pudo calcular el precio del viaje. Intente nuevamente.', {
                                    duration: 10,
                                    estado: 'error'
                                });
                                this.priceLoader = false;
                                this.tripEstimatedPrice = 0;
                                this.estimatedRouteDistanceMeters = null;
                                this.estimatedRouteDurationSeconds = null;
                                return null;
                            }

                            await new Promise(resolve => setTimeout(resolve, 1000 * attempt));
                        }
                    }
                };

                const result = await calculateRouteWithRetry();
                if (!result) {
                    return;
                }

                this.estimatedRouteDistanceMeters = result.distanceValue;
                this.estimatedRouteDurationSeconds = result.timeValue;

                try {
                    const selectedShortcut = this.getSelectedShortcut();
                    const payload = {
                        distance_meters: result.distanceValue,
                        duration_seconds: result.timeValue,
                        origin_lat: this.requestPosition.location.lat,
                        origin_lng: this.requestPosition.location.lng,
                        dest_lat: this.destinationAddress.location.lat(),
                        dest_lng: this.destinationAddress.location.lng(),
                        es_ida_vuelta: this.esIdaVuelta,
                        vehicle_type_id: this.tipoVehiculo,
                        service_type_id: this.tipoServicio,
                        payment_method_id: this.paymentMethodSelected || 0
                    };
                    if (selectedShortcut && selectedShortcut.id) {
                        payload.shortcut_id = selectedShortcut.id;
                    }
                    if (
                        !this.selectedShortcutHasDiscount(selectedShortcut) &&
                        this.settings.modulo_descuento_residente_jubilado &&
                        this.user &&
                        (this.user.beneficio_descuento_aprobado === true || this.user.beneficio_descuento_aprobado === 1 || this.user.beneficio_descuento_aprobado === '1')
                    ) {
                        payload.aplicar_descuento_residente = true;
                    }
                    this.logTarifaAtajo('estimateTripTariff payload', {
                        payload,
                        hasShortcutDiscount: this.selectedShortcutHasDiscount(selectedShortcut),
                        aplicar_descuento_residente: !!payload.aplicar_descuento_residente
                    });
                    const data = await estimateTripTariff(payload);
                    this.logTarifaAtajo('estimateTripTariff respuesta', {
                        price: data.price,
                        precio_sin_descuento: data.precio_sin_descuento,
                        viaje_afuera: !!data.viaje_afuera,
                        precio_no_disponible: data.precio_no_disponible,
                        mensaje: data.mensaje,
                        descuento_aplicado_tipo: data.descuento_aplicado_tipo,
                        descuento_aplicado_pct: data.descuento_aplicado_pct
                    });
                    this.viaje_afuera = !!data.viaje_afuera;
                    this.precioSinDescuento = data.precio_sin_descuento > 0 ? data.precio_sin_descuento : 0;
                    this.tripEstimatedPrice = typeof data.price === 'number' ? data.price : 0;
                    this.descuentoEstimacionTipo = data.descuento_aplicado_tipo || null;
                    this.descuentoEstimacionPct = data.descuento_aplicado_pct != null ? data.descuento_aplicado_pct : null;
                } catch (err) {
                    console.error(err);
                    dialogs.message(this.translate('errorCalculandoPrecio') || 'No se pudo calcular el precio del viaje. Intente nuevamente.', {
                        duration: 10,
                        estado: 'error'
                    });
                    this.tripEstimatedPrice = 0;
                    this.precioSinDescuento = 0;
                    this.descuentoEstimacionTipo = null;
                    this.descuentoEstimacionPct = null;
                    this.estimatedRouteDistanceMeters = null;
                    this.estimatedRouteDurationSeconds = null;
                } finally {
                    this.priceLoader = false;
                }
            } else {
                console.error('In calculateEstimatedPrice(), one of this vars its null: ', this.requestPosition, this.destinationAddress);
            }
        },
        generateShortcutImagePath (image) {
            if (image) {
                return this.$shortcut(image);
            } else {
                return ''; // default image?
            }
        },
        onShortcutToggle () {
            this.shortcutsExpanded = !this.shortcutsExpanded;
        },
        jumpToAddress (address, customPosition) {
            console.log('jumpToAddress', address);
            this.selectedShortcutId = (!customPosition && address && address.id) ? address.id : null;
            if (this.shortcutsExpanded) {
                this.shortcutsExpanded = false;
            }
            if (address.link) {
                console.log('this.platform', this.platform);
                if (address.link_ios && this.platform === 'ios') {
                    window.open(address.link_ios, '_system', 'location=no');
                    return;
                }
                window.open(address.link, '_system', 'location=no');
                return;
            }
            if (this.settings.modulo_edicion_manual_direccion_origen && !customPosition) {
                this.customRequestAddress.title = null;
                this.customRequestAddress.subtitle = null;
            }
            let requestPosition = {
                location: {
                    lat: address.lat,
                    lng: address.lng
                }
            };
            let requestAddress;
            const hasDireccion = !!(address.direccion && String(address.direccion).trim());
            const isShortcutPick = !customPosition && address && address.id;
            // Origen elegido (atajo, dirección manual o autocomplete): no dejar que el mapa lo pise al cargar destino
            this.hasCustomPosition = hasDireccion || !!customPosition || isShortcutPick;
            this.ignoreNextGeocoding = false;

            if (hasDireccion) {
                const parsedNumero = address.numero != null && address.numero !== ''
                    ? Number(address.numero)
                    : 0;
                requestAddress = {
                    calle: address.direccion,
                    numero: Number.isFinite(parsedNumero) ? parsedNumero : 0,
                    barrio: address.barrio
                };
                this.requestAddress = requestAddress;
                this.syncOriginDisplayFromAddress(requestAddress);
                if (this.requestingAdress) {
                    this.requestingAdress = false;
                }
                console.log('this.editingLocation', this.editingLocation);
                this.editingLocation = false;
            } else if (customPosition) {
                this.requestAddress = {
                    calle: this.customRequestAddress.title,
                    numero: -1,
                    barrio: this.customRequestAddress.subtitle
                };
                if (this.requestingAdress) {
                    this.requestingAdress = false;
                }
            } else {
                this.ignoreNextGeocoding = true;
                this.requestingAdress = true;
                this.doReverseGeocoding(requestPosition.location, true);
            }
            // Set requestPosition FIRST to prevent currentPosition watcher from interfering
            this.requestPosition = requestPosition;
            console.log('jumpToAddress: Set requestPosition to', requestPosition.location, 'customPosition:', customPosition, 'hasCustomPosition:', this.hasCustomPosition);
            // Use $nextTick to ensure requestPosition and hasCustomPosition are set before emitting set_center
            // This prevents race conditions with the currentPosition watcher and onLocationChangedOnMap
            this.$nextTick(() => {
                bus.emit('set_center', requestPosition.location);
            });
        },
        /**
         * Debug: descuento atajos_zona al cotizar / crear viaje. Filtrar consola por [tarifa-atajo].
         */
        logTarifaAtajo (step, extra = {}) {
            const selected = this.getSelectedShortcut();
            const info = {
                step,
                selectedShortcutId: this.selectedShortcutId,
                selectedShortcut: selected
                    ? { id: selected.id, descuento: selected.descuento, zona_id: selected.zona_id, title: selected.title }
                    : null,
                currentZonaId: this.currentZona && this.currentZona.id,
                atajosEnPantalla: (this.locationShorcuts || []).map((s) => ({
                    id: s.id,
                    descuento: s.descuento,
                    zona_id: s.zona_id
                })),
                ...extra
            };
            if (typeof console !== 'undefined' && console.debug) {
                console.debug('[tarifa-atajo]', info);
            }
        },
        getSelectedShortcut () {
            if (!this.selectedShortcutId) {
                return null;
            }
            const selectedId = Number(this.selectedShortcutId);
            return this.locationShorcuts.find(s => Number(s.id) === selectedId) || null;
        },
        selectedShortcutHasDiscount (shortcut) {
            if (!shortcut) {
                return false;
            }
            return Number(shortcut.descuento || 0) > 0;
        },
        myPosition () {
            let address = {
                lat: this.currentPosition.lat,
                lng: this.currentPosition.lng
            };
            this.jumpToAddress(address);
        },
        doConfiguration () {
            // Por si en el mounted no estaba listo la settings
            console.log('doConfiguration', this.isRequesting, this.hasFirstRemoteState, this.settings);
            if (this.settings.no_autocompletar_mapa) {
                this.editingLocation = true;
            } else {
                // previous version ubicacion editable was here
            }
            if (this.isRequesting && this.hasFirstRemoteState) {
                if (this.settings.mostrar_mensaje_ubicacion_editable && !this.mostrar_mensaje_ubicacion_editable) {
                    let msg = this.settings.mostrar_mensaje_ubicacion_editable.mensaje;
                    if (this.settings.mostrar_mensaje_ubicacion_editable.i18n) {
                        msg = this.settings.mostrar_mensaje_ubicacion_editable.i18n[this.language];
                    }
                    this.mostrar_mensaje_ubicacion_editable = true;
                    this.$alertForgettable('mostrar_mensaje_ubicacion_editable', msg);
                }
            }
        },
        showConfigPaymentMethod (method) {
            console.log('showConfigPaymentMethod', method);
            if (method && method.options && method.options.recharge_value > 0) {
                this.priceRecharge = {
                    value: method.options.recharge_value,
                    type: method.options.recharge_type
                };
            } else {
                this.priceRecharge = null;
            }
            this.calculateEstimatedPrice();
            if (method && method.options && method.options.vueComponent) { //  && !method.no_configuration
                this.customComponent = method.options.vueComponent;
                this.customPaymentMethod = method;
                let configuration = null;
                if (this.user && this.user.metodosPagosConfigurados && this.user.metodosPagosConfigurados.length) {
                    configuration = this.user.metodosPagosConfigurados.find(m => m.payment_method_id === method.id);
                }
                this.customPaymentMethodConfig = configuration;
            } else {
                this.customComponent = null;
            }
        },
        onPaymentNegotationSuccess () {
        },
        onCanceledTrip (trip) {
            console.log('onCanceledTrip', trip);
            /* let reason = this.translate('viajeCaneladoPorChofer');
            reason += this.cancelReasonModuleEnabled ? (this.translate('reason') + trip.comentario_rechazo) : '';
            let date = moment(trip.created_at).format('HH:mm');
            let mensaje = date + ' - ' + trip.calle + ' ' + (trip.altura > 0 ? trip.altura : '') + ': ';
            mensaje += reason;
            let options = {
                isForgettable: false,
                isModal: false,
                callback: () => {}
            };
            this.$alertForgettable('canceled_trip_' + trip.id, mensaje, options);
            this.caceledViewed(trip.id); */
            showCancelModal.call(this, trip);
        },
        onGoToPromotions () {
            this.$router.push({ name: 'promotions' });
        }
    },
    watch: {
        isLocationEnabled (enabled) {
            if (enabled) {
                this.applyCurrentPositionAsOrigin();
            }
        },
        currentPosition (newValue) {
            if (!newValue) {
                return;
            }
            this.applyCurrentPositionAsOrigin();
        },
        settings () {
            this.doConfiguration();
            // Asegurar que gender tenga un valor válido cuando se carguen las configuraciones
            if (this.settings.modulo_diferenciar_genero && !this.gender) {
                this.gender = 'N';
            }
        },
        hasFirstRemoteState () {
            this.doConfiguration();
        },
        canceledTrip (oldValue, newValue) {
            console.log('canceledTrip watcher', oldValue, newValue);
            if (newValue) {
                if (!oldValue || (oldValue.id !== newValue.id)) {
                    let trip = newValue;
                    this.onCanceledTrip(trip);
                }
            }
        }
    },
    beforeDestroy () {
        bus.off('map_point_selected', this.onLocationChangedOnMap);
        bus.off('drag_start', this.onDragStart);
        bus.off('keyboard-hidden', this.keyboardHidden);
        bus.off('trip_canceled', this.myPosition);
    },
    components: {
        BraintreePayment,
        PaymentezPayment,
        VisanetPayment
    }
};
</script>

<style scoped>
    .card-left,
    .card-center,
    .card-right {
        display: inline-block;
    }

    .card-center {
        width: calc(100% - 66px);
    }

    .card-center label {
        vertical-align: middle;
    }

    .card-right--not {
        width: calc(100% - 36px);
    }

    .card-left {
        margin-right: 8px;
        vertical-align: top;
        margin-top: 4px;
    }

    .card-right {
        margin-right: 8px;
        vertical-align: top;
        margin-top: 4px;
    }
    .card-title {
        padding: 2px 4px;
        display: block;
        font-weight: bold;
        color: var(--card-origin-title)
    }
    .card-row--destination .card-title {
        color: var(--card-destination-title)
    }
    .card-subtitle {
        padding: 2px 4px;
        display: block;
        font-size: .85em;
        margin-top: -2px;
        color: var(--card-origin-subtitle);
    }
    .card-adress-destination {
        box-shadow: 1px 6px 6px 1px rgba(0,0,0,.2);
    }
    .card-adress-destination strong {
        color: var(--main-color);
    }
    .shortcuts-wrapper {
        text-align: right;
        position: relative;
        z-index: 1;
    }
    .shortcuts-wrapper .shorcuts-list {
        position: absolute;
        bottom: 5em;
        right: 0;
        min-width: 70vw;
        text-align: left;
        z-index: 2001;
    }
    .shortcut-item {
        background: transparent;
        border: 0;
        border-bottom: 1px solid var(--text-light-color);
        border-radius: 0;
        width: 100%;
        padding: .8em .5em;
    }
    .shortcut-item--discount {
        background: linear-gradient(90deg, rgba(255, 193, 7, 0.2), rgba(255, 255, 255, 0));
        border-left: 4px solid #ffc107;
    }
    .hidden-screen {
        left: 0;
        top: 0;
        position: fixed;
        background-color: transparent;
        height: 100vh;
        width: 100vw;
        z-index: 1999;
    }
    .logo-first-shortcut {
        background: white;
    }
    .logo-first-shortcut:hover,
    .logo-first-shortcut:focus,
    .logo-first-shortcut:active {
        background: white;
    }
    .shortcuts-laucher img {
        height: 100%;
        max-height: 3em;
    }
    .shortcut-item:last-child {
        border-bottom: 0;
    }
    .shortcut-item_image {
        float: left;
        width: 12vw;
        max-width: 42px;
        max-height: 42px;
        height: auto;
    }
    .shortcut-item_description {
        float: left;
        margin-left: .8em;
        text-align: left;
        width: calc(100% - 60px);
    }
    .shortcut-item_title,
    .shortcut-item_address {
        display: block;
    }
    .shortcut-item_discount {
        display: inline-block;
        margin: 0.25em 0;
        padding: 0.2em 0.5em;
        border-radius: 999px;
        background: #ffc107;
        color: #3a2a00;
        font-size: 0.78em;
        font-weight: 700;
        line-height: 1.2;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    }
    .shortcut-item-my_ubication {
        padding-top: 3px;
    }
    .loader {
        display: inline-block;
        margin-left: 6px;
    }
    .card-row {
        margin-bottom: .6em;
    }
    .card-row:last-of-type {
        margin-bottom: 0;
    }
    div.card-row:first-of-type {
        margin-top: .6em;
        min-height: 36px;
    }
    .card-row--price {
        padding-left: .6em;
    }
    .price-with-discount {
        display: inline-flex;
        flex-wrap: wrap;
        align-items: baseline;
        gap: 0.35em;
    }
    .price-with-discount .price-original {
        text-decoration: line-through;
        opacity: 0.8;
        font-size: 0.95em;
    }
    .price-with-discount .discount-label {
        font-size: 0.85em;
        opacity: 0.9;
    }
    .discount-pending-hint {
        display: block;
        margin: 0.35rem 0 0;
        font-size: 0.85em;
        font-weight: 500;
        color: red;
        line-height: 1.35;
    }
    .card-center--reserva .reserva-help {
        margin: 0.25rem 0 0;
        font-size: 0.85em;
        line-height: 1.35;
        opacity: 0.75;
    }
    .card-center--reserva .reserva-datetime {
        display: flex;
        gap: 0.5rem;
        margin-top: 0.5rem;
        flex-wrap: wrap;
    }
    .card-center--reserva .form-control--date,
    .card-center--reserva .form-control--time {
        flex: 1;
        min-width: 120px;
    }
    .form-radio--block input {
        vertical-align: -3px;
    }
    #rad_tarjeta {
        margin-right: .4em;
    }
    .form-radio--block-text {
        vertical-align: -1.5px;
    }
    .autocomplete_destination {
        margin-top: .3em;
    }
    #destination-edition {
        margin-top: 4px;
    }
    .card-row--destination .card-title{
        padding-top: 6px;
    }
    input[type="text"] {
        border: 1px solid #ccc;
    }
    #comentario {
        border: 1px solid #ccc;
        width: 100%;
        border-radius: 4px;
        padding: 4px;
        height: 3em;
    }
    select {
        -webkit-appearance: none;
        padding-right: 24px;
        background: #fff url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAC33pUWHRSYXcgcHJvZmlsZSB0eXBlIGV4aWYAAHja7ZddsuMoDIXfWcUswZIQEsvB/FT1Dmb5c8Bc5yb3dldNTz/MQ0zFYFkcgT4gSeh//xjhL1yU5QhRzVNO6cAVc8xc0PDjuq6ajrju6+K439GzPdwvGCZBLddj6tu/wK6PDrb96Xy2B6tbx7cQ3cLrkhl5trefbyHhy077OeTdr8RP09kfrlv2Y1ovz9GQjKbQEw7cheTAnWcUwQjEpaA23EkyT0tEe76b9vh97sLdfEne3XrJ3VG2XZ5TEY60HdJLjrad9MUudxh+GhE9Ij+9MLlDfMndGM3H6NfsSkzIVAp7Uh9TWS04nkilrG4JxfBRtG2VjOKYYgWxBponSg2UiZHtQZEaFRrUV12pYoiROxtq5sqybC7GmatcCFBosEmWFsCIpYKawMz3WGjFzSteJUfkRvBkghihx5cSvjP+TrmFxphLl+jwO1cYF881jWFMcvMOLwChsXOqK7+rhE/r5vgEVkBQV5odEyzHeUmcSo+1JYuzwE+PGI5ra5C1LYAUIbZiMCQgcCQSpUSHMRsR8ujgUzBylsgnCJAqNwoDbEQS4DjP2OhjtHxZ+TLjaAEIlYRt4yBUACtGxfqx6FhDRUVjUNWkpq5ZS5IUk6aULM0zqphYNLVkZm7ZiotHV09u7p69ZM6CI0xzyhay55xLQdAC6YLeBR6lnHzKGU8902mnn/ksFcunxqo1Vatecy2NmzRs/5aaheYtt9KpYyn12LWnbt177mVgrQ0ZcehIw4aPPMpNbVN9pkYv5H5NjTa1SSwuP3tQg9nsQ4LmcaKTGYhxJBC3SQALmiezwylGnuQmsyMzNoUyqJFOOI0mMRCMnVgH3ewe5H7JLWj8V9z4Z+TCRPcnyIWJbpP7yu0baq2sbxRZgOYunDk9ZOBgg0P3wl7md9Jv1+G/CryF3kJvobfQW+gt9Bb6/wgN/HjAX83wD0ltkSOzOw3mAAAAPFBMVEV3lbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgYLnfAAAAAXRSTlMAQObYZgAAAAFiS0dEAIgFHUgAAAAJcEhZcwAALiMAAC4jAXilP3YAAAAHdElNRQfiBxMRFAUk9N7VAAAAOklEQVQ4y2NgGAUjBTAy4uYhRJHFUXnYxXGpQZbBrQYhh08NTBa/Gog8ITUwVYRDi7AaXKE4CoYzAACvwABBydOsZwAAAABJRU5ErkJggg==') no-repeat;
        background-size: 20px;
        background-position: right 10px center;
    }
    .h-payment-method {
        margin-top: .5em;
        font-size: 16px;
    }
    .payment-method-radios {
        margin: .5em 0 1em;
    }
    .payment-method-radio {
        display: inline-block;
        margin-right: 1.1em;
        font-size: 1em;
        margin-top: 5px;
    }
    @media screen and (max-width: 450px) {
        .payment-method-radio {
            font-size: 0.9em;
        }
    }
    .shortcut-my-coupons {
        width: 150px;
        display: inline-block;
        float: left;
    }
    .shortcut-my-coupons > span {
        margin-left: .3rem;
    }
    .row-greeting {
        color: var(--text-darker-colo);
        font-size: 1rem;
        border-bottom: 1px dotted #DDD;
    }
    .card-row--distance-estimate {
        display: block;
        margin-top: 0.35rem;
        font-size: 0.9em;
        font-weight: 500;
        color: var(--card-subtitle, #666);
    }
    .request-trip-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 2000;
    }

    .request-trip-container .float-container--bottom,
    .request-trip-container .float-container--top {
        pointer-events: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/elements/passenger/RequestTrip.vue